export { default } from './LineWithText';
